import { Table } from 'react-bootstrap';
import imageLoader from "../images/loader/loaderrrr.gif"
import SortSvg from '../assets/svg/SortSvg';

const SharedTable = ({ columns = [],
    data = [],
    loader = false,
    onRowClick,
    batch = false,
    hideBatchStatus = false,
    batchData = null,
    isDesktop = false
}) => {
    
    return (
        <div style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
            <Table style={{ width: "100%" }} bordered striped className="align-middle graphic-table">
                <thead>
                    <tr>
                        {batch && hideBatchStatus && batchData && batchData?.length > 0 ? <th></th> : <th></th>}
                        {
                            columns.map((item, index) => (
                                <th style={{
                                    maxWidth: item?.width ? item?.width : "fit-content",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                }} key={index}>
                                    {typeof item?.name === "function"
                                        ? item.name()
                                        : item?.name}
                                    {/* <span style={{cursor : "pointer"}}>
                                    <SortSvg/>
                                </span> */}
                                </th>
                            ))
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        loader ? (
                            <tr className=''>
                                <td
                                    colSpan={
                                        columns.length +
                                        (batch && hideBatchStatus && batchData?.length > 0 ? 1 : 0)
                                    }
                                    className="text-center py-5 my-5"
                                >
                                    <img
                                        src={imageLoader}
                                        alt="Loading..."
                                        style={{ height: "50px" }}
                                    />
                                </td>
                            </tr>
                        ) : (
                                <>
                                    {data?.length > 0 ? (
                                        (batch && hideBatchStatus
                                            ? [...data].sort((a, b) => Number(b.batchStatus) - Number(a.batchStatus))
                                            : data
                                        ).map((row, rowIndex) => (
                                            <tr style={{ cursor: "pointer" }} onClick={() => onRowClick && onRowClick(row)} key={rowIndex}>


                                                {batch && hideBatchStatus && batchData && batchData?.length > 0 && row.batchStatus ? (
                                                    rowIndex === 0 ? (
                                                    <td
                                                        rowSpan={batchData?.length}
                                                        className="fst-part-cont"
                                                        style={!isDesktop ? { minWidth: 0, } : null}
                                                    >
                                                        <div
                                                            className={`bg-dark ${!isDesktop ? "" : ""} text-white mr-1 d-flex align-items-center`}>
                                                            <p className="vertical-text">BATCH</p>
                                                        </div>
                                                    </td>
                                                ) : null
                                            ) : <td></td>}

                                            {columns.map((col, colIndex) => {
                                                return (
                                                    <td style={{ maxWidth: col?.width ? col?.width : "fit-content" }} key={colIndex}>
                                                        {col.render(row)}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={columns.length} className="text-center">
                                            No data found
                                        </td>
                                    </tr>
                                )}
                            </>
                        )
                    }

                </tbody>
            </Table>
        </div>
    )
}

export default SharedTable;